import { render, staticRenderFns } from "./ChooseGiftType.vue?vue&type=template&id=0ca44a16&scoped=true&"
import script from "./ChooseGiftType.vue?vue&type=script&lang=js&"
export * from "./ChooseGiftType.vue?vue&type=script&lang=js&"
import style0 from "./ChooseGiftType.vue?vue&type=style&index=0&id=0ca44a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca44a16",
  null
  
)

export default component.exports